module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("I think the Cherokee approach to life is being able")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("to continually move forward with kind of a good mind")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("and not focus on the negative things in your life")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("and the negative things you see around you")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("but focus on the positive things and try to look")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("at the larger picture and keep moving forward.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("—Wilma Mankiller, the first woman chief of the Cherokee Nation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5e91ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_epigraph.vue
// module id = 75
// module chunks = 0